import type {
  LayerGroupFrame,
  LayerGroupHeaderColumn,
} from "@/pages/sy/components/LayerGroupBox";
import {
  getGroupPosition,
  groupConsecutiveLayers,
  isMultiMaterialLayer,
} from "@/pages/sy/utils/layerGroups";

export type LayerGroupHeaderLayout = {
  labelSize: number;
  getColumns: (subtotal: number) => LayerGroupHeaderColumn[];
};

export const EDITABLE_GROUP_HEADER: LayerGroupHeaderLayout = {
  labelSize: 8,
  getColumns: (subtotal) => [{ size: 2, content: `Subtotal: ${subtotal}` }],
};

export const READ_ONLY_GROUP_HEADER: LayerGroupHeaderLayout = {
  labelSize: 6,
  getColumns: (subtotal) => [
    { size: 3 },
    { size: 3, content: `Subtotal: ${subtotal}` },
  ],
};

export const getLayerGroupFrames = <
  T extends { LayerNumber?: number | null; Weight?: number | null },
>(
  layers: T[],
  idKey: keyof T,
  layout: LayerGroupHeaderLayout,
): Map<T[keyof T], LayerGroupFrame> => {
  const frames = new Map<T[keyof T], LayerGroupFrame>();
  for (const group of groupConsecutiveLayers(layers)) {
    if (!isMultiMaterialLayer(group)) continue;
    const subtotal = group.materials.reduce(
      (sum, layer) => sum + (layer.Weight || 0),
      0,
    );
    group.materials.forEach((layer, index) => {
      frames.set(layer[idKey], {
        position: getGroupPosition(index, group.materials.length),
        layerNumber: group.layerNumber,
        labelSize: layout.labelSize,
        columns: layout.getColumns(subtotal),
      });
    });
  }
  return frames;
};
